<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
* {
  // 与 element-ui 表格冲突
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style: none;
  font-size: 14px;
  /*  火狐浏览器的滚动条样式 */
  scrollbar-color: #e2e2e2 #ffffff; /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
}

html,
body,
#app {
  height: 100%;
  background: #f8fbfe;
}
 /* 滚动条统一样式 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #e2e2e2;
  }

  /*滑块效果*/
  ::-webkit-scrollbar-thumb:hover {

    border-radius: 5px;
    background: #c8c8c8;
  }
  .has-background {
    ::-webkit-scrollbar-thumb{
      background-color: #c8c8c8;
    }
  }

#app {
  min-height: 380px;
  font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #181818;

  .tooltip {
    color: #c2c3c4;

    &:hover {
      color: var(--primary, #409EFF);
    }
  }

  /*IE滚动条颜色*/
  scrollbar-face-color: #c8c8c8;
  /*滚动条颜色*/
  scrollbar-highlight-color: #fff;
  scrollbar-3dlight-color: #fff;
  scrollbar-darkshadow-color: #c8c8c8;
  scrollbar-shadow-color: #fff;
  /*滑块边色*/
  scrollbar-arrow-color: #c8c8c8;
  /*箭头颜色*/
  scrollbar-track-color: #fff;
  .el-input.is-disabled .el-input__inner {
    cursor: pointer;
 }

  .fullScreen {
    width: 28px;
    height: 22px;
    display: inline-block;
    cursor: pointer;
    background: url("./components/report/design/assets/fullscreen.png") no-repeat center;
    background-size: 28px 22px;
    margin-left: 38px;
    margin-right: 20px;
    vertical-align: middle;
    margin-bottom: 3px;
    &:hover {
      background: url("./components/report/design/assets/fullscreen-hover.png") no-repeat center;
      background-size: 28px 22px;
    }
    &.exit {
      background: url("./components/report/design/assets/exitfullscreen.png") no-repeat center;
      background-size: 28px 22px;

      &:hover {
        background: url("./components/report/design/assets/exitfullscreen-hover.png") no-repeat center;
        background-size: 28px 22px;
      }
    }
  }

}
.el-dialog {
    border-radius: 4px;
    overflow: hidden;
    .el-dialog__header {
      background: #edeeee;
      padding: 10px 20px;
      .el-dialog__title {
        font-size: 15px;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue